import React, { useState } from 'react';
import './App.css';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import ashridgeBadge from './imgs/ashridge-badge.png';

// Import page components
import Home from './pages/Home';
import Teams from './pages/Teams';
import MatchDayInfo from './pages/MatchDayInfo';
import ClubInfo from './pages/ClubInfo';
import PlayersWanted from './pages/PlayersWanted';
import Footer from './components/Footer';
import Shop from './pages/Shop';
import CookieConsentBanner from './components/CookieConsent';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SiteMap from './pages/SiteMap';
import RegistrationDoc from './pages/RegistrationDoc';
import SoccerSchool from './pages/SoccerSchool';
import Schedule from './pages/Schedule';
import Tournament from './pages/Tournament';
// import TournamentRota from './pages/TournamentRota';
// import TournamentRegistration from './pages/TournamentRegistration';
// import TournamentRegistrationSuccess from './pages/TournamentRegistrationSuccess';
// import TournamentAdmin from './pages/TournamentAdmin';
import CoachesCorner from './pages/CoachesCorner';
import Discounts from './pages/Discounts';
import DiscountReport from './pages/DiscountReport';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';

const SignOutLink: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
  const { session, signOut } = useAuth();
  if (!session) return null;
  return (
    <Nav.Link
      onClick={() => {
        onClick?.();
        signOut();
      }}
      style={{ cursor: 'pointer' }}
    >
      SIGN OUT
    </Nav.Link>
  );
};

const App: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    // Add a wrapper div for positioning context
    // <div style={{ position: 'relative', paddingTop: '35px' }}>
    <AuthProvider>
    <div>
      <header style={{ position: 'relative' }}>

        <div className="navbar-logo-container">
          <img
            alt="Ashridge Park FC Badge"
            src={ashridgeBadge}
            // width="120"
            // height="120"
            className="navbar-logo"
          />
        </div>

        <Navbar
          expanded={expanded}
          onToggle={() => setExpanded(!expanded)}
          variant="dark"
          expand="lg"
          style={{ backgroundColor: '#254E97' }}
          className="main-navbar fixed-top"
          // className="main-navbar"
        >
          <Container>
            {/* Brand text on the left */}
            <Navbar.Brand href="/" className="d-none d-lg-inline">
              ASHRIDGE PARK FC
            </Navbar.Brand>          
            {/* Toggler for mobile */}
            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            {/* Collapsible links on the right */}
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>HOME</Nav.Link>
                <Nav.Link as={Link} to="/teams" onClick={() => setExpanded(false)}>OUR TEAMS</Nav.Link>
                <Nav.Link as={Link} to="/matchdayinfo" onClick={() => setExpanded(false)}>MATCH DAY INFO</Nav.Link>
                <Nav.Link as={Link} to="/clubinfo" onClick={() => setExpanded(false)}>CLUB INFO</Nav.Link>
                <SignOutLink onClick={() => setExpanded(false)} />
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>

      <main className="page-content">
        {/* Define the routes for your pages */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/teams" element={<Teams />} />
          <Route path="/matchdayinfo" element={<MatchDayInfo />} />
          <Route path="/clubinfo" element={<ClubInfo />} />
          <Route path="/playerswanted" element={<PlayersWanted />} />
          <Route path="/tournament" element={<Tournament />} />
          {/* <Route path="/tournament-rota" element={<TournamentRota />} /> */}
          <Route path="/shop" element={<Shop />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/sitemap" element={<SiteMap />} />
          <Route path="/registrationdoc" element={<RegistrationDoc />} />
          <Route path="/soccerschool" element={<SoccerSchool />} />
          <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
          {/* <Route path="/tournament-registration" element={<TournamentRegistration />} />
          <Route path="/tournament-registration/success" element={<TournamentRegistrationSuccess />} /> */}
          {/* <Route path="/tournament-admin" element={<ProtectedRoute><TournamentAdmin /></ProtectedRoute>} /> */}
          <Route path="/coachescorner" element={<CoachesCorner />} />
          {/* Deliberately unlinked rather than authenticated: no nav item, no
              SiteMap entry, not in sitemap.xml. The URL is shared with club
              members directly, and that obscurity is now the only gate. */}
          <Route path="/discounts" element={<Discounts />} />
          <Route path="/discount-report" element={<ProtectedRoute><DiscountReport /></ProtectedRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Wildcard redirects for old URLs and their child pages */}
          <Route path="/The-Club/*" element={<Navigate to="/clubinfo" replace />} />
          <Route path="/News/*" element={<Navigate to="/" replace />} />
          <Route path="/Teams/*" element={<Navigate to="/teams" replace />} />
          <Route path="/Shop/*" element={<Navigate to="/shop" replace />} />
          <Route path="/Contact/*" element={<Navigate to="/" replace />} />
          <Route path="/Sitemap/*" element={<Navigate to="/sitemap" replace />} />
          <Route path="/Player-Registration/*" element={<Navigate to="/teams" replace />} />
          <Route path="/Home/*" element={<Navigate to="/" replace />} />

          {/* Specific redirects (keep these for exact matches if needed) */}
          <Route path="/The-Club/Matchday-Information" element={<Navigate to="/matchdayinfo" replace />} />
          <Route path="/Ashridge/media/Site-Images/general/GotSport-EBFA-only-registration.docx" element={<Navigate to="/registrationdoc" />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsentBanner />
    </div>
    </AuthProvider>
  );
};

export default App;